import {RootStateLocation} from "../store/types";

export type LocationForSpecialtyFilter = Pick<RootStateLocation, "specialtyIds">;

export const filterLocationsBySpecialtyId = <T extends LocationForSpecialtyFilter>(
  locations: T[],
  specialtyId: string,
  limit = 3,
): T[] => locations.filter(l => l.specialtyIds.includes(specialtyId)).slice(0, limit);

export const doesLocationHaveASpecialtyId =
  (specialtyIds: string[]) =>
  (location: {specialtyIds: string[]}): boolean =>
    location.specialtyIds.some(specialtyId => specialtyIds.includes(specialtyId));
